import { createIcon } from '../createIcon.tsx';

export const PlugIcon = createIcon(
	'PlugIcon',
	<>
		<path d="M9 8V3" />
		<path d="M15 8V3" />
		<path d="M5 8h14v3a5 5 0 0 1-5 5h-4a5 5 0 0 1-5-5z" />
		<path d="M12 16v5" />
	</>,
);
